(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var schemata = require('schemata')
  , feePaymentSchema = require('./show-finance-fee-payment-schema')
  , paymentScheduleSchema = require('./payment-schedule-schema')

module.exports = function () {
  return schemata(
    { paymentStatus:
      { type: String
      }
    , paidOutDate:
      { type: Date
      }
    , paymentSchedule:
      { type: schemata.Array(paymentScheduleSchema)
      }
    , feePayments:
      { type: schemata.Array(feePaymentSchema)
      }
    , feePaymentsStatus:
      { type: String
      }
    , feeNotes:
      { type: String
      }
    , contractSent:
      { type: String
      }
    , contractSentStatus:
      { type: String
      }
    , counterSigned:
      { type: String
      }
    , counterSignedStatus:
      { type: String
      }
    , artwork:
      { type: String
      }
    , artworkStatus:
      { type: String
      }
    , setTime:
      { type: String
      }
    , setTimeStatus:
      { type: String
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/contract/show-finance-schema.js","/components/service/contract")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbXBvbmVudHMvc2VydmljZS9jb250cmFjdC9zaG93LWZpbmFuY2Utc2NoZW1hLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQSIsImZpbGUiOiJnZW5lcmF0ZWQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlc0NvbnRlbnQiOlsidmFyIHNjaGVtYXRhID0gcmVxdWlyZSgnc2NoZW1hdGEnKVxuICAsIGZlZVBheW1lbnRTY2hlbWEgPSByZXF1aXJlKCcuL3Nob3ctZmluYW5jZS1mZWUtcGF5bWVudC1zY2hlbWEnKVxuICAsIHBheW1lbnRTY2hlZHVsZVNjaGVtYSA9IHJlcXVpcmUoJy4vcGF5bWVudC1zY2hlZHVsZS1zY2hlbWEnKVxuXG5tb2R1bGUuZXhwb3J0cyA9IGZ1bmN0aW9uICgpIHtcbiAgcmV0dXJuIHNjaGVtYXRhKFxuICAgIHsgcGF5bWVudFN0YXR1czpcbiAgICAgIHsgdHlwZTogU3RyaW5nXG4gICAgICB9XG4gICAgLCBwYWlkT3V0RGF0ZTpcbiAgICAgIHsgdHlwZTogRGF0ZVxuICAgICAgfVxuICAgICwgcGF5bWVudFNjaGVkdWxlOlxuICAgICAgeyB0eXBlOiBzY2hlbWF0YS5BcnJheShwYXltZW50U2NoZWR1bGVTY2hlbWEpXG4gICAgICB9XG4gICAgLCBmZWVQYXltZW50czpcbiAgICAgIHsgdHlwZTogc2NoZW1hdGEuQXJyYXkoZmVlUGF5bWVudFNjaGVtYSlcbiAgICAgIH1cbiAgICAsIGZlZVBheW1lbnRzU3RhdHVzOlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgIH1cbiAgICAsIGZlZU5vdGVzOlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgIH1cbiAgICAsIGNvbnRyYWN0U2VudDpcbiAgICAgIHsgdHlwZTogU3RyaW5nXG4gICAgICB9XG4gICAgLCBjb250cmFjdFNlbnRTdGF0dXM6XG4gICAgICB7IHR5cGU6IFN0cmluZ1xuICAgICAgfVxuICAgICwgY291bnRlclNpZ25lZDpcbiAgICAgIHsgdHlwZTogU3RyaW5nXG4gICAgICB9XG4gICAgLCBjb3VudGVyU2lnbmVkU3RhdHVzOlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgIH1cbiAgICAsIGFydHdvcms6XG4gICAgICB7IHR5cGU6IFN0cmluZ1xuICAgICAgfVxuICAgICwgYXJ0d29ya1N0YXR1czpcbiAgICAgIHsgdHlwZTogU3RyaW5nXG4gICAgICB9XG4gICAgLCBzZXRUaW1lOlxuICAgICAgeyB0eXBlOiBTdHJpbmdcbiAgICAgIH1cbiAgICAsIHNldFRpbWVTdGF0dXM6XG4gICAgICB7IHR5cGU6IFN0cmluZ1xuICAgICAgfVxuICAgIH1cbiAgKVxufVxuIl19